import React from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Approach } from "./components/Approach";
import { Players } from "./components/Players";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans" data-id="element-0" data-mp="2rlyr0hc56qkk">
      <Header data-id="element-1" data-mp="2mlu9qp3etrta" />
      <main data-id="element-2" data-mp="2mm2j470bqezq">
        <Hero data-id="element-3" data-mp="2mmlut5zds75b" />
        <About data-id="element-4" data-mp="2mn5bykh7iria" />
        <Services data-id="element-5" data-mp="2mndna7xolord" />
        <Approach data-id="element-6" data-mp="2mjzmh44o1nm1" />
        <Players data-id="element-7" data-mp="31agn4l9h89hv" />
        <Contact data-id="element-8" data-mp="31aysc7e49y1x" />
      </main>
      <Footer data-id="element-9" data-mp="31c9vq63nh3si" />
    </div>;
}